const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ACTOR_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ACTOR_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "ACTOR_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
